import { AuthenticationType } from 'shell-models-lib';
import { IBaseControlMetadata } from './base-control-metadata';

export interface IAzureDatabricksExistingWorkspaceClusterBindMetadata {
    domain?: string;
    accessToken?: string;
    clusterId?: string;
    credential?: string;
    workspaceResourceId?: string;
}

export enum AuthType {
    token = AuthenticationType.AccessToken,
    msi = AuthenticationType.ManagedServiceIdentity,
    uami = AuthenticationType.UserAssignedManagedIdentity,
    userAuth = AuthenticationType.UserAuth
}

export interface IAzureDatabricksExistingWorkspaceClusterMetadata extends IBaseControlMetadata {
    // eslint-disable-next-line
    type: 'azure-databricks-existing-workspace-cluster-select';
    bind: IAzureDatabricksExistingWorkspaceClusterBindMetadata;
    authType?: AuthType;
}
